const angular = require('angular');
const loginMapper = require('./login-analytics-mapper.js');
const logoutMapper = require('./logout-analytics-mapper.js');
const authenticateMapper = require('./authenticate-analytics-mapper');
const _ = require('lodash');

function LoginService($rootScope, $q, Restangular, globalHeaderPanelService, shopperService, $state, $stateParams, shopPageStateService, settingsService, atm, currentUserService) {
    this._api = Restangular;
    this._edrCardApi = Restangular.one('EdrCard');
    this._q = $q;
    this._rootScope = $rootScope;
    this._state = $state;
    this._stateParams = $stateParams;
    this.panelService = globalHeaderPanelService;
    this.shopperService = shopperService;
    this.shopPageStateService = shopPageStateService;
    this.atm = atm;
    this.logoutLoading = false;
    this.pendingPromptForLogin = {};
    this.currentUserService = currentUserService;

    $rootScope.$on('headerPanel:close', function () {
        if (!this._state.includes('shop.authentication')) {
            // We don't reject the prompt for login when the header panel closes if
            // we are on an authentication page because the user could still log in without using
            // the header panels.
            this.rejectPromptForLogin();
        }
    }.bind(this));

    $rootScope.$on('login:success', this._resolvePromptForLogin.bind(this));

    $rootScope.$on('login:success', this._pushatmLogin.bind(this));

    settingsService.updateSettings();
    const self = this;
    //Load login prompt message settings
    settingsService.getSettingValue('Login', 'LoginToViewCategoryMessage').then(function (msg) { self.LoginToViewCategoryMessage = msg; });
    settingsService.getSettingValue('Login', 'LoginToSavetoListMessage').then(function (msg) { self.LoginToSavetoListMessage = msg; });
    settingsService.getSettingValue('Login', 'LoginToAddRestrictedProductMessage').then(function (msg) { self.LoginToAddRestrictedProductMessage = msg; });
    settingsService.getSettingValue('Login', 'LoginToAddMoreProductsMessage').then(function (msg) { self.LoginToAddMoreProductsMessage = msg; });
    settingsService.getSettingValue('Login', 'LoginToContinueMessage').then(function (msg) { self.LoginToContinueMessage = msg; });
    settingsService.getSettingValue('Login', 'LoginToSetDeliveryOrPickupAddressMessage').then(function (msg) { self.LoginToSetDeliveryOrPickupAddressMessage = msg; });
    settingsService.getSettingValue('Login', 'LoginToSetDeliveryWindowMessage').then(function (msg) { self.LoginToSetDeliveryWindowMessage = msg; });
    self.LoginSessionHasExpiredMessage = 'Please Login. Your Session Has Expired.';
}

LoginService.prototype.login = function (email, password, reCaptchaConfig = {}) {
    const self = this;
    const { token, action, version } = reCaptchaConfig;
    const reCaptchaPayload = token ? {
        GoogleReCaptchaResponse: token,
        Action: action,
        Version: version
    } : {};
    const loginPromise = self._api.one('Login').post('Login', Object.assign(
        {
            Email: email,
            Password: password,
            RememberMe: true
        },
        reCaptchaPayload
    ));

    const shopperPromise = loginPromise.then(function (loginResult) {
        if (loginResult.LoginResult.toLowerCase() === 'success') {
            const user = self.currentUserService.get();
            user.isStaffMember = !_.isNull(loginResult.IsReviewer) ? loginResult.IsReviewer : false;
            self.currentUserService.set(user);

            return self.shopperService.getCurrentShopperDetails()
                       .then(() => loginResult);
        }

        return loginResult;
    });

    const balanceSummaryPromise = shopperPromise.then(function (loginResult) {
        if (loginResult.LoginResult.toLowerCase() === 'success' && loginResult.HasPrimaryEdrCard) {
            self._edrCardApi.one('BalanceSummary').get()
                .then((response) => {
                    if (response.IsEdrCardUnlinked) {
                        const user = self.currentUserService.get();
                        user.edrNumber = self.shopperService.EdrNumber = '';
                        user.hasEdrCard = self.shopperService.HasEdrCard = false;

                        self.currentUserService.set(user);
                    }
                });
        }

        return loginResult;
    });

    return self._q.all([loginPromise, shopperPromise, balanceSummaryPromise])
        .then(function (promiseResults) {
            return promiseResults[0];
        })
        .then(this.onLogin.bind(this));
};

LoginService.prototype.verifyOTP = function (email, password, code, mobile) {
    const payload = !!mobile ? {
        Email: email,
        Password: password,
        RememberMe: true,
        Code: code,
        Phone: mobile
    } : {
        Email: email,
        Password: password,
        RememberMe: true,
        Code: code
    };
    return this._api.one('Login').post('Verify', payload);
};

LoginService.prototype.sendOTP = function (email, password, mobile) {
    const payload = !!mobile ? {
        Email: email,
        Password: password,
        RememberMe: true,
        Phone: mobile
    } : {
        Email: email,
        Password: password,
        RememberMe: true
    };
    return this._api.one('Login').post('SendOtp', payload);
};

LoginService.prototype.onLogin = function (loginResult) {
    this._rootScope.$broadcast('login:' + loginResult.LoginResult.toLowerCase(), loginResult, self.pendingPromptForLogin || {});
    return loginResult;
};

LoginService.prototype.logout = function () {
    this.atm.push('header', logoutMapper);
    this._rootScope.$broadcast('logout:start');
    const self = this;
    self.logoutLoading = true;
    const freshDeliveryLocation = { SuburbName: '' };
    this.currentUserService._$local.setItem('deliveryLocation', JSON.stringify(freshDeliveryLocation));
    this.shopperService.setIdVerificationToken('');
    return this._api.one('/').post('Logout').then(function (response) {
        if (response.Success === true) {
            self.currentUserService.clear();
            if (self._state.current.name === 'shop.myaccount' || self._state.current.name === 'shop.persistentlogin') {
                location.href = '/';
            } else {
              location.reload();
            }
        } else {
            self.logoutLoading = false;
        }
    });
};

LoginService.prototype.loginInAsNewUser = function () {
    this._rootScope.$broadcast('logout:start');
    const self = this;
    return this._api.one('/').post('Logout').then(function (response) {
        if (response.Success === true) {
            location.reload(true);
            self._state.go('shop.authentication.login');
            self.shopperService.currentUser.isGuest = true;
            self.currentUserService.clear();
        }
    });
};

LoginService.prototype.promptForLogin = function (message, toState, toParams, navigate) {
    /// <summary>
    /// Prompt a user for login. Used before performing an action that requires authentication.
    /// </summary>
    /// <param name="message">(Optional) The message to prompt the user with.</param>
    /// <param name="toState">(Optional) The state which should be navigated to after login. Defaults to the current state.</param>
    /// <param name="toParams">
    /// (Optional) The params for the state which should be navigated to after login. Defaults to the
    /// current state params.
    /// </param>
    /// <param name="navigate">
    /// (Optional) If true, the login will be performed by navigating to the login page. Otherwise, the login will
    /// use the popover login panel. Navigation always happens in small format, checkout, and when the session expires.
    /// </param>
    /// <returns type="Promise">
    /// A promise which will be resolved when the login is successful. If the login is aborted, the promise will reject.
    /// </returns>
    if (this.pendingPromptForLogin.loginDeferred) {
        // If there is already a prompt pending, we can return the
        // existing promise for the pending prompt.
        return this.pendingPromptForLogin.loginDeferred.promise;
    }

    // If the caller provides a toState, we want to redirect after logging in.
    const shouldRedirectAfterLogin = !!toState;
    const shouldRedirectToLoginPage = navigate;

    this.loginPromptMessage = message;

    this.pendingPromptForLogin = {
        navigate: shouldRedirectToLoginPage,
        toState: toState === undefined ? this._state.$current : toState,
        toParams: toParams === undefined ? angular.copy(this._stateParams) : toParams,
        loginDeferred: this._q.defer(),
        willRedirect: shouldRedirectAfterLogin || shouldRedirectToLoginPage
    };

    if (shouldRedirectToLoginPage) {
        this._state.go('shop.authentication.login');
        this.shopPageStateService.triggerPanel('left', true);
    } else {
        this.panelService.openPanel(this.panelService.panels.login);
    }

    return this.pendingPromptForLogin.loginDeferred.promise
        .then(function () {
            if (shouldRedirectAfterLogin || shouldRedirectToLoginPage) {
                this._state.go(this.pendingPromptForLogin.toState, this.pendingPromptForLogin.toParams);
            }
        }.bind(this))
        .finally(function () {
            this.loginPromptMessage = null;
            this.pendingPromptForLogin = {};
        }.bind(this));
};

LoginService.prototype._resolvePromptForLogin = function () {
    if (this.pendingPromptForLogin.loginDeferred) {
        this.pendingPromptForLogin.loginDeferred.resolve();
    }
};

LoginService.prototype.rejectPromptForLogin = function () {
    /// <summary>
    /// If there is an action pending which has prompted for login, this will reject the pending login promise.
    /// </summary>
    if (this.pendingPromptForLogin.loginDeferred) {
        this.pendingPromptForLogin.loginDeferred.reject();
    }
};

LoginService.prototype._pushatmLogin = function () {
    /// <summary>
    /// If there is an successful login process pust to atm
    /// </summary>
    const stateName = this._state.current.name;
    if (stateName === 'shop.persistentlogin') {
        this.atm.push('persistentlogin', loginMapper);
    } else if (stateName === 'shop.authentication.login') {
        this.atm.push('My Account', authenticateMapper);
    } else {
        this.atm.push('header', loginMapper);
    }
};

LoginService.prototype.appendAttemptsRemaining = function (response) {
    const attemptsRemaining = response.RemainingRetry;
    let errorMessage = response.AuthenticationErrorMessage;

    if (attemptsRemaining) {
        errorMessage += attemptsRemaining > 0 ? `<br/><br/><strong><i class="fa fa-explantation"></i>${attemptsRemaining} attempt${attemptsRemaining > 1 ? 's' : ''} remaining</strong>` : '';
    }

    return errorMessage;
};

LoginService.prototype.setRedirectTo = function (routeName, routeParams) {
    this.redirectTo = {
        routeName,
        routeParams
    };
};

LoginService.prototype.redirectAfterLogin = function () {
    if (this.redirectTo && !!this.redirectTo.routeName) {
        window.location.href = this._state.href(this.redirectTo.routeName, this.redirectTo.routeParams) || '/';
    } else {
        window.location.href = '/';
    }
};

LoginService.prototype.cancelLoginAndRedirect = function () {
    if (this.redirectTo && !!this.redirectTo.routeName) {
        this._state.go(this.redirectTo.routeName, this.redirectTo.routeParams);
        this.redirectTo = null;
    } else {
        this._state.go('home');
    }
};

module.exports = LoginService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-service.js
 **/